import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";

const Terms = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <Helmet>
        <title>FitCalendar Terms & Conditions</title>
        <link rel="canonical" href="https://fitcalendar.praxipro.io/terms/" />
        <meta name="title" content="FitCalendar Terms & Conditions" />
        <meta name="description" content="Read the FitCalendar Terms & Conditions outlining user responsibilities, privacy policies, and service guidelines for our yoga, Pilates, and fitness booking software." />
        <meta name="author" content="PraxiPro" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fitcalendar.praxipro.io/terms/" />
        <meta property="og:title" content="FitCalendar Terms & Conditions - User Agreement & Policies" />
        <meta property="og:description" content="Understand your rights and responsibilities as a user of FitCalendar’s booking software. Read our Terms & Conditions and Privacy Policies." />
        <meta property="og:image" content="/og-image.png" />
        <meta property="og:site_name" content="FitCalendar" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://fitcalendar.praxipro.io/terms/" />
        <meta name="twitter:title" content="FitCalendar Terms & Conditions - User Agreement & Policies" />
        <meta name="twitter:description" content="Review FitCalendar’s Terms & Conditions to understand user policies, privacy, and guidelines for using our booking software." />
        <meta name="twitter:image" content="/og-image.png" />
        <meta name="twitter:creator" content="@PraxiPro" />

        <meta itemProp="name" content="FitCalendar Terms & Conditions - User Agreement & Policies" />
        <meta itemProp="description" content="FitCalendar’s Terms & Conditions detail user responsibilities, privacy policies, and service terms for our yoga, Pilates, and fitness studio software." />
        <meta itemProp="image" content="/og-image.png" />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <h1 className="text-3xl font-bold mb-8">{t('terms.title')}</h1>
      <div className="termsContainer">
        <h2>{t('terms.scope.title')}</h2>
        <p>{t('terms.scope.description')}</p>

        <h2>{t('terms.services.title')}</h2>
        <p>{t('terms.services.description')}</p>
        <ul>
          <li>{t('terms.services.features.browse')}</li>
          <li>{t('terms.services.features.manage')}</li>
        </ul>
        <p>{t('terms.services.disclaimer')}</p>

        <h2>{t('terms.registration.title')}</h2>
        <ul>
          <li>{t('terms.registration.points.accurateInfo')}</li>
          <li>{t('terms.registration.points.confidentiality')}</li>
          <li>{t('terms.registration.points.payment')}</li>
        </ul>

        <h2>{t('terms.booking.title')}</h2>
        <ul>
          <li>{t('terms.booking.points.binding')}</li>
          <li>{t('terms.booking.points.cancellationPolicy')}</li>
          <li>{t('terms.booking.points.refunds')}</li>
        </ul>

        <h2>{t('terms.responsibilities.title')}</h2>
        <ul>
          <li>{t('terms.responsibilities.points.lawfulUse')}</li>
          <li>{t('terms.responsibilities.points.studioRules')}</li>
        </ul>

        <h2>{t('terms.liability.title')}</h2>
        <ul>
          <li>{t('terms.liability.points.injuries')}</li>
          <li>{t('terms.liability.points.technicalMalfunctions')}</li>
        </ul>

        <h2>{t('terms.dataProtection.title')}</h2>
        <ul>
          <li>{t('terms.dataProtection.points.gdpr')}</li>
        </ul>

        <h2>{t('terms.termination.title')}</h2>
        <ul>
          <li>{t('terms.termination.points.suspension')}</li>
        </ul>

        <h2>{t('terms.governingLaw.title')}</h2>
        <ul>
          <li>{t('terms.governingLaw.points.germanLaw')}</li>
          <li>{t('terms.governingLaw.points.disputeResolution')}</li>
        </ul>
      </div>
    </div>
  );
};

export default Terms;